import { EmailPreview } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/EmailPreview';
import { TextArea } from '@dealstack/frontend/shared/components/forms/TextArea/TextArea';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { GLOBAL_MEDIA_QUERIES } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { memo } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import styled from 'styled-components';

interface Props {
	className?: string;
	form: UseFormReturn<{ email_body_text: string }>;
	inputName: string;
	bodyText: string;
	previewTitle: string;
	emailPreviewTitle: string;
	emailPreviewChild?: React.ReactNode;
}

const InvitationPreview = ({
	className,
	form,
	inputName,
	bodyText,
	previewTitle,
	emailPreviewTitle,
	emailPreviewChild,
}: Props) => {
	const tMipCreate = useTranslationMipCreate();
	return (
		<div className={className}>
			<ContentWrapper>
				<div>
					<SectionHeader size="h5b" title={tMipCreate('invite.body.title')} />
					<FormProvider {...form}>
						<form onSubmit={() => void 0}>
							<TextArea
								label={tMipCreate('invite.body.label')}
								name={inputName}
								rows={28}
								fullWidth
							/>
						</form>
					</FormProvider>
				</div>
				<div>
					<SectionHeader size="h5b" title={previewTitle} />
					<EmailPreview
						bodyText={bodyText}
						title={emailPreviewTitle}
						child={emailPreviewChild}
					/>
				</div>
			</ContentWrapper>
		</div>
	);
};

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 3em;

	${EmailPreview} {
		margin-left: auto;
		margin-right: auto;
	}

	@media (min-width: ${GLOBAL_MEDIA_QUERIES.laptop}) {
		flex-direction: row;
		gap: 6em;

		${EmailPreview} {
			margin-left: unset;
			margin-right: unset;
		}

		& > div:first-of-type {
			flex-basis: 60%;
		}

		& > div:nth-of-type(2) {
			flex-basis: 40%;
		}
	}
`;

const Memoized = memo(InvitationPreview);
const Styled = styled(Memoized)`
	${TextArea} {
		textarea {
			font-size: 0.875rem;
			line-height: 140%;
		}
	}

	${SectionHeader} {
		margin: 1em 0;
	}

	${EmailPreview} {
		margin-top: 2em;
	}
`;

export { Styled as EmailInvitationPreview };
